import * as React from 'react';
import { Button, TUnderlineDropdownItem, UnderlineDropdown } from '@assetmark/common-elements';
import { IProfile } from '../../profileComponent';

import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './investmentReason.module.css';

export interface InvestmentReasonProps {
    onNextButtonClick: (event: any, data: IProfile) => void;
    onBackButtonClick: (event: any, data: IProfile) => void;
    data?: any;
    investmentReasons: TUnderlineDropdownItem[];
    buttonLabel?: {key: any, back: string, next: string}[]
}

interface InvestmentState {
    data: IProfile;
    buttonLabel: {key: any, back: string, next: string}[];
    backBtn: string,
    nextBtn: string
}

export class InvestmentReason extends React.Component<
    InvestmentReasonProps,
    InvestmentState
> {
    constructor(props) {
        super(props);

        const initialData = this.props.data;
        initialData.investmentReason = this.props.data.investmentReason ? this.props.data.investmentReason : "Retirement";

        this.state = {
            data: initialData,
            buttonLabel: this.props.buttonLabel || [],
            backBtn: 'BACK',
            nextBtn: 'SET YOUR GOALS'
        };

        this.onChange = this.onChange.bind(this);
    }

    public onChange(e) {
        const newData = this.state.data;
        newData.investmentReason = e.target.value;
        this.setState({ data: newData });
        // button text and name
        this.btnTextHandler(e.target.value);
       
    }

    componentDidMount() {
        this.btnTextHandler(this.state.data.investmentReason);
    }

    public btnTextHandler(selectedOption) {
        const seletedOptionArr =  this.state.buttonLabel.filter(option => option.key === selectedOption);
        if(seletedOptionArr && seletedOptionArr.length) {
            this.setState({ backBtn: seletedOptionArr[0].back,
            nextBtn: seletedOptionArr[0].next });
        }else {
            this.setState({ backBtn: 'BACK',
                nextBtn: 'SET YOUR GOALS' });
        }
    }

    public render() {
        return (
            <div className={`${styles.investment_reason_component} col-sm-12`}>
                <h1 className={`${styles.title}`}>Investment Reason</h1>
                <div className={`row label-text ${styles.labelText}`}>
                    <div className="col-sm-12">
                        I am investing for &nbsp;
                        <UnderlineDropdown
                            name="InvestmentType"
                            value={this.state.data.investmentReason}
                            options={this.props.investmentReasons}
                            onChange={this.onChange}
                            isDisabled={false}
                            className={`dropdown ${styles.underline_dropdown}`}
                        />
                    </div>
                </div>
                <div className={`row ${styles.mt_row_btn}`}>
                    <div className="col-sm-12">
                        <Button
                            text={`${this.state.backBtn}`}
                            name={`${this.state.backBtn}`}
                            className={`button button-secondary button-lg back-button ${styles.lineHeightClass}`}
                            onClick={(e) => this.props.onBackButtonClick(e, this.state.data)}
                        />
                        <Button
                            text={`${this.state.nextBtn}`}
                            name={`${this.state.nextBtn}`}
                            className={`button button-primary button-lg ml-2 ${styles.lineHeightClass}`}
                            onClick={(e) => this.props.onNextButtonClick(e, this.state.data)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
